import { memo } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { AuraLayout, Layout } from "lola-framework-ui-test";
import { TITLE_COLOR } from "../../constants";
import { useStore } from "../../store/globalState";
import { useSessionStore } from "../../store/useSessionStore";
import { TermsMarkdown } from "../../components/request/TermsMarkdown";
import "../../styles/legal.style.css";
import { ScrollFadeIndicator } from "../../components/ScrollFadeIndicator";
import { Navbar } from "../../components/Navbar";


/**
 * Detail viewer for a single partner-configured Terms & Conditions entry,
 * resolved from the (mock) session by `?entryId=`.
 */
export const TermDetailPage = memo(() => {
  const { theme } = useStore();
  const colorConfig = theme.whiteView;
  const { bodyCopy } = colorConfig;
  const navigate = useNavigate();
  const { t } = useTranslation("cash-deposit");
  const [searchParams] = useSearchParams();
  const { session } = useSessionStore();

  const entryId = searchParams.get("entryId");
  const entry = session.data?.terms?.entries.find((e) => e.id === entryId);

  const title = entry?.detailTitle || t("terms.title");

  return (
    <AuraLayout
      colorConfig={colorConfig}
      className="term-detail-page"
    >
      <Layout.Header>
        <Navbar
          onBackClick={() => navigate(-1)}
          title={title}
          align="center"
          color={TITLE_COLOR}
        />
      </Layout.Header>
      <Layout.Content isOverflowauto>
        <ScrollFadeIndicator color={bodyCopy} />
        <section className="term-detail-wrapper" style={{ color: bodyCopy }}>
          {entry ? (
            <TermsMarkdown content={entry.detailMarkdown} />
          ) : (
            <p className="muted-foreground">{t("terms.notFound")}</p>
          )}
        </section>
      </Layout.Content>
    </AuraLayout>
  );
});
